import { createSlotRecipe } from './runtime.js';

const noticeConfig = {"name":"notice","slots":["root","contentWrapper","content","icon","text","title","message","actionWrapper","confirmButton","closeButton","closeButtonIcon"],"variantMap":{"hasTitle":["false","true"],"status":["basic","error","info","success","warning"],"type":["action","default","inline"]}}

export const notice = /* @__PURE__ */ createSlotRecipe(noticeConfig)